import { render, staticRenderFns } from "./SelectVideo.vue?vue&type=template&id=044e7dfe&scoped=true&"
import script from "./SelectVideo.vue?vue&type=script&lang=js&"
export * from "./SelectVideo.vue?vue&type=script&lang=js&"
import style0 from "./SelectVideo.vue?vue&type=style&index=0&id=044e7dfe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044e7dfe",
  null
  
)

export default component.exports